import PuxTranslate from "../PuxTranslate/PuxTranslate.vue";

// @vue/component
export default {
  name: "PuxRequired",
  components: {
    PuxTranslate,
  },
};
